import { v4 as uuidv4 } from 'uuid';

// Collection of realistic profile images
const profileImages = [
    'https://randomuser.me/api/portraits/men/1.jpg',
    'https://randomuser.me/api/portraits/women/2.jpg',
    'https://randomuser.me/api/portraits/men/3.jpg',
    'https://randomuser.me/api/portraits/women/4.jpg',
    'https://randomuser.me/api/portraits/men/5.jpg',
    'https://randomuser.me/api/portraits/women/6.jpg',
    'https://randomuser.me/api/portraits/men/7.jpg',
    'https://randomuser.me/api/portraits/women/8.jpg',
];

// Collection of realistic names
const firstNames = ['James', 'Sarah', 'Michael', 'Emily', 'David', 'Olivia', 'Daniel', 'Sophia', 'William', 'Emma', 'Matthew', 'Ava', 'Joseph', 'Isabella', 'Christopher', 'Mia'];
const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Miller', 'Davis', 'Garcia', 'Rodriguez', 'Wilson', 'Martinez', 'Anderson', 'Taylor', 'Thomas', 'Moore', 'Jackson'];

// Job titles
const jobTitles = [
    'Account Manager',
    'Project Manager',
    'Sales Representative',
    'Marketing Specialist',
    'Production Assistant',
    'Technical Director',
    'Audio Engineer',
    'Graphic Designer',
    'Event Coordinator',
    'Operations Manager',
    'Client Liaison',
    'Creative Director',
    'Lighting Technician',
    'Video Producer',
    'Logistics Coordinator'
];

// Companies
const companies = [
    'Sunset Productions',
    'Harmony Events',
    'MasterSound Ltd',
    'Visionary Media Group',
    'Spotlight Solutions',
    'Elite Entertainment',
    'Apex Audio Visual',
    'Stellar Events Co',
    'Creative Concepts',
    'Premier Productions'
];

// Domain names for email
const domains = ['gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com', 'company.com', 'business.co.uk', 'productions.co', 'events.com'];

// Generate a random date within the last year
const generateRecentDate = () => {
    const now = new Date();
    const pastDate = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
    const randomTime = pastDate.getTime() + Math.random() * (now.getTime() - pastDate.getTime());
    return new Date(randomTime).toISOString().slice(0, 10);
};

// Generate user names for notes
const userNames = ['Alice Smith', 'Bob Johnson', 'Carol Williams', 'Dave Brown', 'Eve Jones', 'Frank Miller', 'Grace Davis'];

// Generate document types
const documentTypes = ['Contract', 'Invoice', 'Proposal', 'Agreement', 'License', 'Certificate', 'Resume', 'Portfolio'];

// Generate realistic phone numbers
const generatePhoneNumber = () => {
    return `+44 ${Math.floor(Math.random() * 1000)}-${Math.floor(Math.random() * 1000)}-${Math.floor(Math.random() * 10000)}`.replace(/\b(\d{1})\b/g, '0$1');
};

// Generate random notes
const generateNotes = (count = 3) => {
    const notes = [];
    const noteTemplates = [
        'Called to discuss upcoming project',
        'Sent email regarding availability',
        'Met at industry conference',
        'Provided quote for services',
        'Followed up on proposal',
        'Discussed contract terms',
        'Scheduled meeting for next week',
        'Reviewed portfolio',
        'Updated contact information',
        'Confirmed attendance for event'
    ];

    for (let i = 0; i < Math.min(count, 10); i++) {
        notes.push({
            id: uuidv4(),
            date: generateRecentDate(),
            note: noteTemplates[Math.floor(Math.random() * noteTemplates.length)],
            user: userNames[Math.floor(Math.random() * userNames.length)]
        });
    }

    return notes;
};

// Generate random documents
const generateDocuments = (count = 2) => {
    const documents = [];
    const documentNames = [
        'Project Overview',
        'Contract Agreement',
        'Event Proposal',
        'Technical Rider',
        'Invoice',
        'Equipment List',
        'Schedule',
        'Production Notes',
        'Service Agreement',
        'Performance Contract'
    ];

    for (let i = 0; i < Math.min(count, 10); i++) {
        documents.push({
            id: uuidv4(),
            name: documentNames[Math.floor(Math.random() * documentNames.length)],
            date: generateRecentDate(),
            type: documentTypes[Math.floor(Math.random() * documentTypes.length)]
        });
    }

    return documents;
};

// Generate address data
const generateAddress = () => {
    const streets = ['High Street', 'Station Road', 'Main Street', 'Park Avenue', 'Church Road', 'London Road', 'Victoria Road', 'Green Lane'];
    const towns = ['London', 'Manchester', 'Birmingham', 'Liverpool', 'Glasgow', 'Edinburgh', 'Bristol', 'Leeds'];
    const counties = ['Greater London', 'Greater Manchester', 'West Midlands', 'Merseyside', 'Lanarkshire', 'Edinburgh', 'Avon', 'West Yorkshire'];
    const postcodes = ['SW1A 1AA', 'M1 1AA', 'B1 1AA', 'L1 1AA', 'G1 1AA', 'EH1 1AA', 'BS1 1AA', 'LS1 1AA'];

    return {
        address1: `${Math.floor(Math.random() * 100) + 1} ${streets[Math.floor(Math.random() * streets.length)]}`,
        address2: Math.random() > 0.5 ? `Suite ${Math.floor(Math.random() * 20) + 1}` : '',
        town: towns[Math.floor(Math.random() * towns.length)],
        county: counties[Math.floor(Math.random() * counties.length)],
        postcode: postcodes[Math.floor(Math.random() * postcodes.length)],
        country: 'United Kingdom'
    };
};

// Create a fake contact
export const createFakeContact = (id = null) => {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const name = `${firstName} ${lastName}`;
    const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@${domains[Math.floor(Math.random() * domains.length)]}`;

    return {
        id: id || uuidv4(),
        name,
        jobTitle: jobTitles[Math.floor(Math.random() * jobTitles.length)],
        number: generatePhoneNumber(),
        email,
        company: Math.random() > 0.3 ? companies[Math.floor(Math.random() * companies.length)] : '',
        description: `${name} is a professional contact with experience in the events and production industry.`,
        image: Math.random() > 0.2 ? profileImages[Math.floor(Math.random() * profileImages.length)] : null,
        isBookable: Math.random() > 0.5,
        isVat: Math.random() > 0.7,
        notes: generateNotes(Math.floor(Math.random() * 5)),
        documents: generateDocuments(Math.floor(Math.random() * 3)),
        address: generateAddress(),
        tags: Math.random() > 0.4 ? ['VIP', 'Regular', 'Preferred'].slice(0, Math.floor(Math.random() * 3) + 1) : []
    };
};

// Generate multiple fake contacts
export const generateFakeContacts = (count = 10) => {
    const contacts = [];
    for (let i = 0; i < count; i++) {
        contacts.push(createFakeContact(i + 1));
    }
    return contacts;
}; 